import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { t } from "i18next";
import { Notification } from "../../interface/user";
import React, { FC, useEffect, useState } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { NOTIFICATION_METHOD_DROPDOWN } from "../../utils/dropdown/notification";
import { setNotificationSetting } from "../../api/user";
import { useWindowWidth } from "hooks/hooks";

type NotificationItem = Notification & {
	notificationMethod?: Notification["NotificationMethod"];
	notificationMethodId?: number;
};

export const NotificationPage: FC<{ data?: Notification[] }> = ({
	data = [],
}) => {
	const [notifications, setNotifications] = useState<NotificationItem[]>(data);
	const windowWidth = useWindowWidth();
	const isMobileView = windowWidth < 768;

	useEffect(() => {
		setNotifications(data);
	}, [data]);

	const getNotificationMethod = (item: NotificationItem) =>
		item.notificationMethod || item.NotificationMethod;

	const handleNotificationMethodChange = (data: {
		notificationMethodId: string;
		notificationEventId: string;
	}) => {
		setNotificationSetting(data)
			.then((res) => {
			})
			.catch((err) => {
				console.error("Error updating notification setting", err);
			});
	};

	const updateNotificationMethod = (
		item: NotificationItem,
		method: { id: number; name: string; nameEnglish: string },
	) => {
		setNotifications((current) =>
			current.map((entry) =>
				entry.id === item.id
					? {
						...entry,
						notificationMethod: method,
						NotificationMethod: method,
						notificationMethodId: method.id,
						NotificationMethodId: method.id,
					}
					: entry,
			),
		);

		handleNotificationMethodChange({
			notificationMethodId: String(method.id),
			notificationEventId: String(item.id),
		});
	};

	const CustomCell = (props: any) => {
		const notificationMethod = getNotificationMethod(props);
		return (
			<td style={{ textAlign: "center" }}>
				<DropDownList
					style={{ width: "100%" }}
					data={NOTIFICATION_METHOD_DROPDOWN}
					dataItemKey="id"
					textField="name"
					value={{
						id: notificationMethod?.id,
						name: t(notificationMethod?.name || ""),
					}}
					onChange={(e) =>
						updateNotificationMethod(props, {
							id: e.target.value.id,
							name: e.target.value.name,
							nameEnglish: e.target.value.nameEnglish || "",
						})
					}
					popupSettings={{ width: "auto" }}
				/>
			</td>
		);
	};

	return (
		<div style={{ height: "100%", borderTop: "1px solid #dee2e6" }}>
			{isMobileView ? (
				<div className="user-profile-setting-mobile-list">
					{notifications.length === 0 && (
						<div className="user-profile-setting-mobile-empty">
							{t("NoDataFound")}
						</div>
					)}
					{notifications.map((item) => {
						const notificationMethod = getNotificationMethod(item);

						return (
							<div key={item.id} className="user-profile-setting-mobile-card">
								<div className="user-profile-setting-mobile-card-header user-profile-setting-mobile-card-header--simple">
									<div className="user-profile-setting-mobile-card-title">
										{item.event}
									</div>
									<div className="user-profile-setting-mobile-card-subtitle">
										{item.description}
									</div>
								</div>
								<div className="user-profile-setting-mobile-card-body">
									<div className="user-profile-setting-mobile-card-field">
										<span className="user-profile-setting-mobile-card-label">
											{t("Method")}
										</span>
										<DropDownList
											style={{ width: "100%" }}
											data={NOTIFICATION_METHOD_DROPDOWN}
											dataItemKey="id"
											textField="name"
											value={{
												id: notificationMethod?.id,
												name: t(notificationMethod?.name || ""),
											}}
											onChange={(e) =>
												updateNotificationMethod(item, {
													id: e.target.value.id,
													name: e.target.value.name,
													nameEnglish: e.target.value.nameEnglish || "",
												})
											}
											popupSettings={{ width: "auto" }}
										/>
									</div>
								</div>
							</div>
						);
					})}
				</div>
			) : (
				<Grid
					style={{ overflowY: "hidden" }}
					data={notifications}
					className="hide-virtual-scroll"
				>
					<GridColumn field="event" title={t("Incident")} />
					<GridColumn field="description" title={t("Description")} />
					<GridColumn
						field="notificationMethod.id"
						title={t("Method")}
						width="150px"
						cells={{
							data: (prop) => <CustomCell {...prop.dataItem} />,
						}}
					/>
				</Grid>
			)}
		</div>
	);
};
